import SectionTitle    from '../ui/SectionTitle'
import TestimonialCard from '../ui/TestimonialCard'
import { useTestimonials } from '../../hooks/useTestimonials'

const FALLBACK = [
  {
    id:           1,
    client_name:  'Sarah M.',
    client_role:  'Happy Parent',
    rating:       5,
    client_emoji: '😊',
    review_text:  "They made my son's day unforgettable. Everything was perfectly organized!",
  },
  {
    id:           2,
    client_name:  'Ahmed K.',
    client_role:  'Happy Parent',
    rating:       5,
    client_emoji: '😊',
    review_text:  'Professional team, amazing decoration, and the kids had so much fun!',
  },
]

export default function Testimonials() {
  const { data: testimonials, isLoading } = useTestimonials()
  const items = testimonials?.length ? testimonials.slice(0, 2) : FALLBACK

  return (
    <section className="section-padding bg-surface">
      <div className="container-custom">
        <SectionTitle
          eyebrow="Reviews"
          title="What Our Clients Say"
          subtitle="Hear from the families who trusted us with their most special moments."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {(isLoading ? Array(2).fill(null) : items).map((t, i) =>
            isLoading ? (
              <div key={i} className="h-56 skeleton" />
            ) : (
              <TestimonialCard
                key={t.id}
                clientName={t.client_name}
                clientRole={t.client_role}
                reviewText={t.review_text}
                emoji={t.client_emoji}
                rating={t.rating ?? 5}
                index={i}
              />
            )
          )}
        </div>
      </div>
    </section>
  )
}
